import React,{useState, useEffect, useRef} from 'react';
import { Image, Navbar, Nav, Container} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFeather, faCircleNotch, faTimes, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import Card from '../card';
import FlipCard from '../flipcard';
import ShuffleCard from '../shufflecard';
import Note from '../note';
import ChakraInfo from './chakraInfo';
import { isMobile, isTablet, isIOS } from 'react-device-detect';
import { useSpring, a } from '@react-spring/web'
import { useLanguage } from '../../i18n/LanguageContext';

function Chakra(props) {
  const { language, t } = useLanguage();
  const [canRotate, setCanRotate] = useState(false);
  const [rotation, setRotation] = useState(props.cards ? props.cards.rotation || 0 : 0); // Initialize rotation from props if available
  const lastAngle = useRef(null);
  const lastMouse = useRef(null);
  const [chakraCards, setCards] = useState(["cover","cover","cover","cover","cover","cover","cover"]);
  const [chakraLabels, setLabels] = useState(() => {
    const l = t('chakraSpread.labels');
    return Array.isArray(l) ? l : ["Root","Sacral","Solar\nPlexus","Heart","Throat","Third\nEye","Crown"];
  });
  const [chakraColors, setColors] = useState(["red","orange","#ffe082","#4caf50","cornflowerblue","#673ab7","purple"]);
  const [chakraPositions, setPositions] = useState(() => {
    const p = t('chakraSpread.positions');
    return Array.isArray(p) ? p : ["1st","2nd","3rd","4th","5th","6th","7th"];
  });
  const [chakraCard, setCard] = useState("0"); //for popup
  const [showChakraInfo, setShowchakraInfo] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showInstruction, setShowInstruction] = useState(props.cards ? false : true);
  const [showNote, setShowNote] = useState(false);
  const [showSaved, setShowSaved] = useState(true);
  const [saved, setSaved] = useState(props.cards);

  const [shuffle, setShuffle] = useState(["new","new","new","new","new","new","new"]);
  const [flipped, setFlipped] = useState([false, false, false, false, false, false, false]);
  const [update, setUpdate] = useState(0); //for popup

  const [width, setWidth]   = useState(window.outerWidth);
  const [height, setHeight] = useState(window.outerHeight);

  const updateDimensions = () => {
    setWidth(window.outerWidth);
    setHeight(window.outerHeight);
  }

  //const { opacity, zIndex } = useSpring({
  //  to: {opacity: (showInstruction) ? 1 : 0, zIndex: (showInstruction) ? 99 : -1},
  //  config: { mass: 5, tension: 500, friction: 80, duration:1000 }
  //});

  const rotate = () => {
    if (window.screen && window.screen.orientation){
      const {type, angle} = window.screen.orientation;
      if (type.indexOf("portrait") >= 0){
        var newHeight = height;
        var newWidth = width;
        if (width > height){
          newHeight = width;
          newWidth = height;
        }
      }
      else{ //landscape
        var newHeight = height;
        var newWidth = width;
        if (height > width){
          newHeight = width;
          newWidth = height;
        }
      }
      //alert("rotation type: " + type + " ,angle: " + angle + " ,currentWidth: " + width + " setWidth:[" + newWidth + "]");
      setWidth(newWidth);
      setHeight(newHeight);
    }
    else{
      var angle = window.orientation;
      if (angle == 0 || angle == 180){
        var newHeight = height;
        var newWidth = width;
        if (width > height){
          newHeight = width;
          newWidth = height;
        }
      }
      else{ //landscape
        var newHeight = height;
        var newWidth = width;
        if (height > width){
          newHeight = width;
          newWidth = height;
        }
      }
      //alert("rotation type: " + type + " ,angle: " + angle + " ,currentWidth: " + width + " setWidth:[" + newWidth + "]");
      setWidth(newWidth);
      setHeight(newHeight);
    }
    
  }

  useEffect(() => {
    const l = t('chakraSpread.labels');
    if (Array.isArray(l)) setLabels(l);
    const p = t('chakraSpread.positions');
    if (Array.isArray(p)) setPositions(p);
  }, [language]);

  useEffect(() => {
    
    if (isMobile){
      if (window.screen && window.screen.orientation){
        window.screen.orientation.addEventListener("change", rotate);
      }
      else{
        window.addEventListener("orientationchange", rotate);
      }
    }
    else{
      window.addEventListener("resize", updateDimensions);
    }
    
    setTimeout(function(){
     setShowInstruction(false)
    },18000)

    return function(){
      if (isMobile){
        if (window.screen && window.screen.orientation){
          window.screen.orientation.removeEventListener("change", rotate);
        }
        else{
          window.removeEventListener("orientationchange", rotate);
        }
      }
      else{
        window.removeEventListener("resize", updateDimensions);
      }
    } 

  },[]);

  if (chakraCards[0] == "cover"){
    if (props.cards){
      setShuffle(["false","false","false","false","false","false","false"]);
      setCards(props.cards.cards);
      setFlipped([true, true, true, true, true, true, true]); // <-- Ensure all flipped
      setShowSaved(true);
    }
    else{
      var keys = getRandomKeys(7);
      setCards(keys);
      setFlipped([false, false, false, false, false, false, false]); // <-- Reset flipped
      setShowSaved(false);
    }
  }

 function handleClick(index, isFlipped) {
  if (isFlipped) {
    setCard(chakraCards[index]);
    handleShow();
  } else {
    // Mark this card as flipped
    const newFlipped = [...flipped];
    newFlipped[index] = true;
    setFlipped(newFlipped);

    const allFlipped = newFlipped.every(val => val === true);
    setShowSaved(allFlipped);
    setCanRotate(allFlipped);
  }
}

  function getRandomKeys(count){
    var keys = [];
    for (var i=0;i<count;i++){
      var key = getRandomKey(keys);
      keys.push(key);
    }
    return keys;
  }

  function getKey(){
    var key;

    for (var i=0; i<7; i++){
      key = (Math.floor(Math.random() * 108) + 1).toString();
    }

    return key;
  }
  
  function getRandomKey(exitingKeys){
    var key = getKey();
    if (exitingKeys.indexOf(key)>=0){
      return getRandomKey(exitingKeys);
    }
    else{
      return key;
    }
  }

  function handleSelect(key){
    if (key=="new"){
      if (update > 0){
        setCards(["cover","cover","cover","cover","cover","cover","cover"]);
        setSaved(null);
        setTimeout(function(){
          setShuffle(["shuffle","shuffle","shuffle","shuffle","shuffle","shuffle","shuffle"]);
        },500)
      }
    }
    else if (key=="back"){
      props.onBackSelected();
    }
    else if (key=="save"){
      setShowNote(true);
    }
  }

  function handleBaseClick(index){
    shuffle[index]="false";
    var count = update + 1;
    setUpdate(count);
    setShowInstruction(false)
  }

  function handleShuffle(index){
    shuffle[index]="new";
    //var count = update + 1;
    //setUpdate(count);
    setCanRotate(false)
    setRotation(0); // Reset rotation when shuffling
  }

  function getCard(key, shuffle, height, width, card){
    if (shuffle[key] == "new" || shuffle[key] == "shuffle"){
      return (<ShuffleCard key={key} cardno={key + 1} onClick={handleBaseClick.bind(this,key)} onShuffle={handleShuffle.bind(this,key)} height={height} width={width} shuffle={shuffle[key]}></ShuffleCard>)
    }
    else{
      return (<FlipCard key={key} cardno={key + 1} onClick={handleClick.bind(this,key)} card={card} flipped={flipped[key]} height={height} width={width}></FlipCard>)
    }
  }

  function handleNoteClose(saved, cards){
    setShowNote(false)
    if (saved){
      setSaved(cards);
    }
  }

  function handleMouseMove(e) {
    if (!canRotate) return;

    // Get the bounding rect of the spread container
    const spread = document.getElementById('chakra-spread');
    if (!spread) return;
    const rect = spread.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    // Mouse position relative to center
    const x = e.clientX - centerX;
    const y = e.clientY - centerY;

    // Calculate angle from center to mouse
    const angle = Math.atan2(y, x);

    if (lastAngle.current === null) {
      lastAngle.current = angle;
      return;
    }

    // Calculate the difference in angle
    let delta = angle - lastAngle.current;

    // Normalize delta to [-PI, PI]
    if (delta > Math.PI) delta -= 2 * Math.PI;
    if (delta < -Math.PI) delta += 2 * Math.PI;

    setRotation(r => r + delta);
    lastAngle.current = angle;
  }

  function handleMouseLeave() {
  lastMouse.current = null;
  lastAngle.current = null;
}

  function getCards(){
    var h = height;
    var w = width;
    var vmin = Math.min(Math.min(h,1100) - 350 , w);

    if (vmin >= h - 270 && (w > h - 270)){
      vmin = h - 270;
    }

  
    if (vmin < 400){
      if (w > h) {
        vmin = 400;
      } else {
        vmin = w;
      }
    }

    var cardHeight = (0.23 * vmin * 1.2) + "px";
    var cardWidth = (0.23 * vmin) + "px";
    var spreadWidth = vmin;
    var spreadHeight = vmin;

    // Circle layout
    const numCards = 7;
    const centerX = spreadWidth / 2 + 23;
    const centerY = spreadHeight / 2;
    const radiusX = spreadWidth * 0.35; // horizontal radius
    const radiusY = spreadWidth * 0.38; // vertical radius makes oval shape
    const rotationOffset = -Math.PI; // place first card (index 0) directly at the top

    const cardDivs = chakraCards.map((card, i) => {
      const rawAngle = (2 * Math.PI * i) / numCards + Math.PI / 2 
      const angle = rawAngle + rotation + rotationOffset; // Adjust angle to start from the top
      //const angle = (2 * Math.PI * i) / numCards - Math.PI / 2 + rotation // Adjust angle to start from the top
      
      var x = centerX + radiusX * Math.cos(angle) - parseFloat(cardWidth) / 2 - 30;
      var y = centerY + radiusY * Math.sin(angle) - parseFloat(cardHeight) / 2 - 0;

      // Smooth slot-based extra offset for position 4/5 (lower area), but no hard jump
      const anglePerPosition = 2 * Math.PI / numCards;
      const baseAngle = Math.PI / 2 + rotationOffset;
      let position = Math.floor((angle - baseAngle) / anglePerPosition);
      position = ((position % numCards) + numCards) % numCards;
      const centerSlotAngle = baseAngle + position * anglePerPosition;
      const slotDiff = Math.atan2(Math.sin(angle - centerSlotAngle), Math.cos(angle - centerSlotAngle));
      const slotWeight = Math.max(0, 1 - Math.abs(slotDiff) / (anglePerPosition * 0.5));
      //if (position === 3 || position === 4) y += 22 * slotWeight;

       // Calculate the placeholder angle (where the card "should" be if not rotated)
      const placeholderAngle = (2 * Math.PI * i) / numCards + Math.PI / 2 + rotationOffset;

      // Find the difference between current and placeholder angle
      let diff = Math.abs((angle - placeholderAngle) % (2 * Math.PI));
      if (diff > Math.PI) diff = 2 * Math.PI - diff; // Normalize to [0, PI]

      // Check if this card is close to ANY placeholder position
      let isAtPlaceholder = false;
      for (let j = 0; j < numCards; j++) {
        const placeholderAngle = (2 * Math.PI * j) / numCards + Math.PI / 2 + rotationOffset;
        let diff = Math.abs((angle - placeholderAngle) % (2 * Math.PI));
        if (diff > Math.PI) diff = 2 * Math.PI - diff; // Normalize to [0, PI]
        if (diff < 0.10) { // ~8.5 degrees, adjust as needed
          isAtPlaceholder = true;
          break;
        }
      }

      return (
        <div
          key={i}
          style={{
            position: 'absolute',
            top: `${y}px`,
            left: `${x}px`,
            opacity: canRotate ? (isAtPlaceholder ? 1 : 0.7) : 1
          }}
        >
          {getCard(i, shuffle, cardHeight, cardWidth, chakraCards[i])}
        </div>
      );
    });

/*
// Place labels at a smaller radius (e.g., 60% of card radius)
const labelRadius = radius * 0.44;

const labelDivs = chakraLabels.map((label, i) => {
  const angle = (2 * Math.PI * i) / numCards + Math.PI / 2 + rotationOffset; // Adjust angle to start from the top
  const x = centerX + labelRadius * Math.cos(angle);
  const y = centerY + labelRadius * Math.sin(angle);

  // Optional: rotate the label to match the slice
  var rotateDeg = (angle * 180) / Math.PI + 90;
  rotateDeg = ((rotateDeg % 360) + 360) % 360;

   // Flip text if it's upside down (angle between 90 and 270 degrees)
  if (rotateDeg > 90 && rotateDeg < 270) {
    rotateDeg += 180;
  }

  return (
    <div
      key={i}
      style={{
        position: 'absolute',
        left: `${x}px`,
        top: `${y}px`,
        pointerEvents: 'none',
        color: 'lightgray',
        fontSize: '0.65rem',
        whiteSpace: 'pre-line',
        textAlign: 'center',
        fontWeight: 'bold',
        lineHeight: 0.9,
        transform: `translate(-50%, -50%) rotate(${rotateDeg}deg)`
      }}
    >
      {label}
    </div>
  );
});
*/
/*
const positionRadius = radius * 0.28;
const positionDivs = chakraPositions.map((label, i) => {
  const angle = (2 * Math.PI * i) / numCards + Math.PI / 2 + rotationOffset; // Adjust angle to start from the top
  const x = centerX + positionRadius * Math.cos(angle);
  const y = centerY + positionRadius * Math.sin(angle);

  // Optional: rotate the label to match the slice
  var rotateDeg = (angle * 180) / Math.PI + 90;
  rotateDeg = ((rotateDeg % 360) + 360) % 360;

   // Flip text if it's upside down (angle between 90 and 270 degrees)
  if (rotateDeg > 90 && rotateDeg < 270) {
    rotateDeg += 180;
  }

  return (
    <div
      key={i}
      style={{
        position: 'absolute',
        left: `${x}px`,
        top: `${y}px`,
        pointerEvents: 'none',
        color: 'gray',
        fontWeight: 'bold',
        fontSize: '0.7rem',
        transform: `translate(-50%, -50%) rotate(${rotateDeg}deg)`
      }}
    >
      {label}
    </div>
  );
});
*/
    return (
      <div 
      id="chakra-spread"
      style={{
        height: spreadHeight,
        width: spreadWidth,
        maxHeight: 900,
        maxWidth: 900,
        minHeight: "300px",
        minWidth: "300px",
        position: 'relative'
      }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      
      // For touch support:
      onTouchMove={e => {
        if (e.touches.length === 1) {
          handleMouseMove({
            clientX: e.touches[0].clientX,
            clientY: e.touches[0].clientY
          });
        }
      }}
      onTouchEnd={handleMouseLeave}
      >
        <div style={{
          position: 'absolute',
          top: 0,
          left:20,
          width: "100%",
          height: "100%"
        }}>
          <Image src="graphics/chakra2.png" width="95%" height="95%" style={{ opacity: 1.0, zIndex: 0 }} />
        </div>
        {cardDivs}
      </div>
    );
    
  }

  function getTitle(){
    if(saved){
      return saved.title
    }
    else{
      return t('spreads.chakra.title') + " " + chakraCards.join(',');
    }
  }

  function getScrollHeight(){
    var scrollHeight = "'auto'";
    if (height < 500){
      scrollHeight = 'calc(' + height.toString() + 'px + 280px - env(safe-area-inset-top) - env(safe-area-inset-bottom))';
    }
      return scrollHeight;
    }

  function stopRotationAndReorder() {
    setShowInstruction(false)
    if (canRotate) {
      //setCanRotate(false);
      //reorderCardsByRotation();
    } 
  }

  function toggleRotationAndReorder() {
    if (canRotate) {
      //setCanRotate(false);
      //reorderCardsByRotation();
    } else {
      //setCanRotate(true); // Only Nav.Link enables rotation
    }
  }

  function showManualInstruction(event) {
    event.stopPropagation();
    setShowchakraInfo(true);
  }

  var bgColor = "#fff";
  var fgColor = "#999";
  if (props.theme == "dark"){
      bgColor = "#000";
      fgColor = "#D3D3D3";
  }
  var saveNote = t('common.saveNotes');
  if (saved){
    saveNote = t('common.notes');
  }

  var time = "";
  if (props.cards){
    time = props.cards.time;
  }

  var titlespace = '15px';
  if (height < 800){
     titlespace = '0px';
  }
  
  return (
    <div onClick={stopRotationAndReorder}>
    <Navbar fixed="top" bg={props.theme} variant={props.theme} style={{width: "100%", paddingBottom:0, paddingTop:'calc(env(safe-area-inset-top) + 10px)'}}>
      <Nav fill style={{width: "100%"}} className="justify-content-end" onSelect={handleSelect}>
        <Nav.Link eventKey="back" style={{textAlign: "left", marginLeft:"10px"}}><span aria-hidden="true" class="carousel-control-prev-icon" style={{verticalAlign:'middle'}} onTouchEnd={handleSelect.bind(this, "back")}/></Nav.Link>
        <Nav.Link eventKey="new" hidden={props.cards != null}><span style={{verticalAlign:'middle'}}><FontAwesomeIcon icon={faCircleNotch}  size='1x' /> {t('common.shuffle')}</span></Nav.Link>
        {/*<Nav.Link
          eventKey="rotate"
          disabled={!flipped.every(val => val === true)}
          style={{ opacity: flipped.every(val => val === true) ? 1 : 0.5 }}
          onClick={toggleRotationAndReorder}
        >
          <span style={{verticalAlign:'middle'}}>
            <FontAwesomeIcon icon={faSyncAlt} size='1x' />
            {canRotate ? " Stop Rotation" : " Rotate"}
          </span>
        </Nav.Link>*/}
        <Nav.Link eventKey="back" hidden={props.cards == null}><span style={{verticalAlign:'middle'}}>{time}</span></Nav.Link>
        <Nav.Link eventKey="save" style={{opacity: (showSaved) ? 1 : 0}}><span style={{verticalAlign:'middle'}}><FontAwesomeIcon icon={faFeather}  size='1x'/> {saveNote}</span></Nav.Link>
      </Nav>
  </Navbar>
    <Container
      fluid
      style={{
        overflow: 'hidden',
        paddingTop: '75px',
        paddingBottom: '85px',
        height: getScrollHeight(),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <div style={{ color: fgColor, paddingTop: titlespace, marginBottom: '25px' }}>
        <b>{t('spreads.chakra.title')}</b>
        <button
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '1.0em',
            color: fgColor,
            paddingLeft: 10
          }}
          onClick={showManualInstruction}
          aria-label={t('spreads.chakra.showInstructions')}
        >
          <FontAwesomeIcon icon={faInfoCircle}/> {/* Replace with faInfoCircle if available */}
        </button>
      </div>
      {getCards()}

    </Container>
    {showInstruction && 
    <div className="semitext" style={{ position: 'fixed', bottom: 70,  zIndex:showInstruction ? 99 : -1, opacity: showInstruction ? 1 : 0}}>
      <button
      onClick={() => setShowInstruction(false)}
      aria-label={t('spreads.chakra.closeInstructions')}
      style={{
        position: 'absolute',
        top: 4,
        right: 4,
        background: 'none',
        border: 'none',
        fontWeight: 100,
        color: 'gray',
        cursor: 'pointer'
      }}
    >
      <FontAwesomeIcon icon={faTimes} size='lg'/>
    </button>
      {t('chakraSpread.instruction')}
    </div>
   }
    <Card card={chakraCard} show={show} placement="bottom" name="bottom" onHide={handleClose} ></Card>
    <Note className="saveCardDialog" cards={chakraCards} rotation={rotation} title={getTitle()} saved={saved} type="chakra" show={showNote} onHide={handleNoteClose}></Note>
   <ChakraInfo className="saveCardDialog" 
    show={showChakraInfo}
    onHide={() => setShowchakraInfo(false)}
   />
    </div>
  )
};

export default Chakra;